import { Component } from '@angular/core';

@Component({
  selector: 'app-loader',
  standalone: true,
  template: `
    <div
      class="mt-2 mb-2 ms-4 md:ms-0 bg-white/50 backdrop-blur-sm rounded-[10.4px] p-4 shadow-sm border border-white flex items-center justify-center"
      style="width: 60px; height: 60px;"
    >
      <div class="relative w-[28px] h-[28px] rounded-full overflow-hidden">
     
        <div
          class="absolute inset-0 rounded-full animate-spin-slow"
          style="background: conic-gradient(from 180deg at 50% 50%, #5810FF 0deg, #E3D7FF 360deg)"
        ></div>

        <div class="absolute inset-[4px] bg-white rounded-full"></div>
      </div>
    </div>
  `,
  styles: [`
    @keyframes spin {
      from { transform: rotate(0deg); }
      to   { transform: rotate(360deg); }
    }
    .animate-spin-slow {
      animation: spin 1.2s linear infinite;
    }
  `]
})
export class LoaderComponent {}
